import { useTranslation } from 'react-i18next';
import { trackGTMEvent } from './GoogleTagManager';
import { trackEventMp } from './Mixpanel';
import { trackEvent } from './Hotjar';
import { useBannerContext } from '@/contexts/BannerContext';

const Header = () => {
  const { t } = useTranslation();
  const { isBannerVisible } = useBannerContext();
  
  const handleProductHuntClick = () => {
    trackGTMEvent('product_hunt_badge_click', {
      event_category: 'engagement',
      event_label: 'header_badge',
      source: 'header'
    });
    trackEventMp('product_hunt_badge_click');
    trackEvent('product_hunt_badge_click');
  };

  const handleAIForThatClick = () => {
    trackGTMEvent('ai_for_that_badge_click', {
      event_category: 'engagement',
      event_label: 'header_badge',
      source: 'header'
    });
    trackEventMp('ai_for_that_badge_click');
    trackEvent('ai_for_that_badge_click');
  };
  
  return (
    <header className={`relative z-20 w-full pt-4 ${isBannerVisible ? 'mt-16 md:mt-0' : ''}`}>
      {/* Background gradient for header */}
      <div className="absolute inset-0 bg-newsletter-gradient-subtle opacity-30" />
      <div className="absolute top-0 left-1/3 w-64 h-64 bg-newsletter-primary/5 rounded-full blur-3xl" />
      <div className="absolute top-0 right-1/3 w-64 h-64 bg-newsletter-accent/5 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center text-center">
          <img 
            src="/assets/logo.png" 
            alt={t('header.logoAlt')}
            className="h-20 sm:h-24 md:h-28 w-auto max-w-full object-contain my-4"
            style={{ filter: 'hue-rotate(12deg) brightness(1.15) contrast(0.95)' }}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;